import type { Lead, LeadStatus } from "@/domain/models/lead";
import type { CreateLeadInput, LeadRepository } from "@/domain/repositories/lead.repository";
import type { HttpClient } from "@/infrastructure/http/http-client";
import { mapLeadDto, type LeadDto } from "@/infrastructure/mappers/lead.mapper";

export class HttpLeadRepository implements LeadRepository {
  constructor(private readonly http: HttpClient) {}

  async list(): Promise<Lead[]> {
    const rows = await this.http.get<LeadDto[]>("/leads");
    return rows.map(mapLeadDto);
  }

  async getById(id: string): Promise<Lead | null> {
    const row = await this.http.get<LeadDto | null>(`/leads/${id}`);
    return row ? mapLeadDto(row) : null;
  }

  async create(input: CreateLeadInput): Promise<Lead> {
    const row = await this.http.post<LeadDto>("/leads", input);
    return mapLeadDto(row);
  }

  async updateStatus(id: string, status: LeadStatus): Promise<Lead> {
    const row = await this.http.patch<LeadDto>(`/leads/${id}/status`, { status });
    return mapLeadDto(row);
  }

  async update(id: string, input: Partial<Lead>): Promise<Lead> {
    const row = await this.http.patch<LeadDto>(`/leads/${id}`, input);
    return mapLeadDto(row);
  }
}
